export default "__VITE_ASSET__DSFC9TX___"